// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__1etdR","error":"Button_error__3vkcf","success":"Button_success__3pNnR","primary":"Button_primary__3cTQU"};